import React, { memo } from 'react';
import { Checkbox } from 'antd';
import { useFormMethods, useFormWatch } from '../../../../helpers/formManager';
import { fieldPathBuilders } from '../../shared/configs/acceptanceForm';
import useDebouncedFunc from '../../../../hooks/useDebounsedFunc';
import {
  scheduleTypeIds,
  defaultScheduleTypeId,
} from '../../shared/configs/selectionData/scheduleTypes';
import styles from './index.module.scss';

const {
  desk: {
    scheduleType: createScheduleTypeName,
    isCommonSchedules: createIsCommonSchedulesName,
  },
  deskScheduleSetting: { byEntity: createScheduleSettingByEntityName },
} = fieldPathBuilders;

const createWatchNames = (deskIndex) => [
  createScheduleTypeName(deskIndex),
  createIsCommonSchedulesName(deskIndex),
];

const CheckboxFactory = ({ deskIndex, ...props }) => {
  const [scheduleType = defaultScheduleTypeId, isCommonSchedules = true] =
    useFormWatch({ name: createWatchNames(deskIndex) });

  const showActiveCheckbox =
    scheduleType === scheduleTypeIds.byWeekDays && !isCommonSchedules;

  return showActiveCheckbox ? (
    <ActiveCheckbox deskIndex={deskIndex} {...props} />
  ) : (
    <BaseCheckbox {...props} />
  );
};

const MemoizedCheckbox = memo(CheckboxFactory);

export default MemoizedCheckbox;

function BaseCheckbox({ value, label, checked, ...props }) {
  return (
    <Checkbox
      {...props}
      checked={checked}
      value={value}
      className={styles.checkbox}
    >
      {label}
    </Checkbox>
  );
}

function ActiveCheckbox({ value, label, checked, deskIndex, ...props }) {
  const name = createScheduleSettingByEntityName(deskIndex, value);

  const { unregister } = useFormMethods();

  const handleChange = (e) => {
    if (!e.target.checked) {
      unregister(name);
    }
  };
  const onDebouncedChange = useDebouncedFunc(handleChange, 500, true);

  return (
    <Checkbox
      {...props}
      checked={checked}
      value={value}
      onChange={onDebouncedChange}
      className={styles.checkbox}
    >
      {label}
    </Checkbox>
  );
}
